export class PayrollPendingWorksheetsSummaryDto {
  draftCount: number;

  readyForReviewCount: number;

  totalCount: number;
}
